export default __webpack_public_path__ + "static/media/halima.505a8f05.png";